import { MutationOptions } from '@tanstack/react-query';
import { createZipFileQueryFunction } from '@/modules/FileDetail/queries/documentation/createZip/createZipFile/createZipFileQueryFunction';
import {
  CreateZipQueryResponseType,
  CreateZipType,
} from '@/modules/FileDetail/queries/documentation/createZip/createZipFile/createZipFileQuery.type';

export const createZipFileQueryOptions = (): MutationOptions<
  CreateZipQueryResponseType,
  Error,
  CreateZipType
> => ({
  mutationKey: ['downloadZipFileQueryOptions'],
  mutationFn: (params: CreateZipType) =>
    createZipFileQueryFunction({
      id: params.id,
    }),
});
